import loadable from '@loadable/component'

export const RegistrationWrapper = loadable(
  () => import('./RegistrationWrapper')
)
export type { RegistrationWrapperProps } from './RegistrationWrapper'
